import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommentsModule } from '@helios/comments'
import { FilterModalModule } from '@helios/filter-modal'
import { GenericComponentsModule } from '@helios/generic-components'
import {
  NgbAccordionModule,
  NgbAlertModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import {
  GridWrapperModule,
  TableLayoutModule,
} from '@northfork/ag-grid-angular'
import {
  ButtonModule,
  DatepickerModule,
  FileSelectModule,
  InlineEditModule,
  LoaderModule,
  NfFormsModule,
  SearchModule,
  TableModule,
} from '@northfork/ng-basics'
import { BreakHistoryComponent } from './components/break-history/break-history.component'
import { BulkBreakModalComponent } from './components/bulk-break-modal/bulk-break-modal.component'
import { BulkBreakGroupComponent } from './components/bulk-break-group/bulk-break-group.component'
import { CreateIssueModalComponent } from './components/create-issue-modal/create-issue-modal.component'
import { FindMultiBreaksPopoverComponent } from './components/find-multi-breaks-popover/find-multi-breaks-popover.component'
import { HoldModalComponent } from './components/hold-modal/hold-modal.component'
import { MultiBreaksGridComponent } from './components/multi-breaks-grid/multi-breaks-grid.component'
import { MultiFileUploadModalComponent } from './components/multi-file-upload/multi-file-upload-modal.component'
import { NoteEditorComponent } from './components/note-editor/note-editor.component'
import { NoteModalComponent } from './components/note-modal/note-modal.component'
import { ResolveModalComponent } from './components/resolve-modal/resolve-modal.component'
import { MultiBreaksPanelComponent } from './multi-breaks-panel.component'
import { HttpMultiBreaksService } from './services/http-multi-breaks.service'
import { HttpReconInsightService } from './services/http-recon-insight.service'
import { MultiBreaksService } from './services/multi-breaks.service'
import { ReconInsightService } from './services/recon-insight.service'
import { BreaksValidationComponent } from './components/breaks-validation/breaks-validation.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NfFormsModule,
    NgbModalModule,
    SearchModule,
    NgbAccordionModule,
    GridWrapperModule,
    TableLayoutModule,
    FilterModalModule,
    ButtonModule,
    HttpClientModule,
    FilterModalModule,
    GridWrapperModule,
    LoaderModule,
    NgbPopoverModule,
    GenericComponentsModule,
    DatepickerModule,
    NgbTooltipModule,
    InlineEditModule,
    NgSelectModule,
    NgbAlertModule,
    TableModule,
    FileSelectModule,
    NgbNavModule,
    NgbDropdownModule,
    CommentsModule,
  ],
  declarations: [
    MultiBreaksPanelComponent,
    MultiBreaksGridComponent,
    ResolveModalComponent,
    NoteModalComponent,
    NoteEditorComponent,
    HoldModalComponent,
    BreakHistoryComponent,
    FindMultiBreaksPopoverComponent,
    CreateIssueModalComponent,
    MultiFileUploadModalComponent,
    BreaksValidationComponent,
    BulkBreakModalComponent,
    BulkBreakGroupComponent,
  ],
  providers: [
    {
      provide: MultiBreaksService,
      useClass: HttpMultiBreaksService,
    },
    {
      provide: ReconInsightService,
      useClass: HttpReconInsightService,
    },
  ],
  exports: [MultiBreaksPanelComponent],
})
export class MultiBreaksModule {}

export { MultiBreaksPanelComponent }
